import React, { createContext, useState, useEffect } from 'react';
import appLogger from '../utils/appLogger';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [restaurantDetails, setRestaurantDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    // Check for existing authentication on app load
    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('authToken');
            const userData = localStorage.getItem('userData');
            const restaurantData = localStorage.getItem('restaurantData');

            if (token && userData) {
                try {
                    const parsedUser = JSON.parse(userData);
                    const parsedRestaurant = restaurantData ? JSON.parse(restaurantData) : null;
                    
                    setUser(parsedUser);
                    setIsAuthenticated(true);
                    setRestaurantDetails(parsedRestaurant);
                } catch (error) {
                    console.error('Error parsing stored auth data:', error);
                    clearAuthData();
                }
            }
            setLoading(false);
        };

        checkAuth();
    }, []);

    const login = (userData, restaurantData = null) => {
        setUser(userData);
        setIsAuthenticated(true);
        setRestaurantDetails(restaurantData);
        
        // Store in localStorage for persistence
        localStorage.setItem('authToken', userData.token || 'demo-token');
        localStorage.setItem('userData', JSON.stringify(userData));
        if (restaurantData) {
            localStorage.setItem('restaurantData', JSON.stringify(restaurantData));
        }
    };

    const logout = () => {
        appLogger.log('Logout', { action: 'logout' });
        setUser(null);
        setIsAuthenticated(false);
        setRestaurantDetails(null);
        clearAuthData();
    };

    const clearAuthData = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('restaurantData');
    };

    const updateRestaurantDetails = (details) => {
        setRestaurantDetails(details);
        if (details) {
            localStorage.setItem('restaurantData', JSON.stringify(details));
        }
    };

    return (
        <UserContext.Provider value={{ 
            user, 
            isAuthenticated, 
            restaurantDetails,
            loading,
            login, 
            logout,
            updateRestaurantDetails
        }}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;